import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, lastValueFrom, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';
import { RoleService as ApiRoleService, RoleView } from '@src/api';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private readonly roleService = inject(ApiRoleService);
  private readonly ngxPermissionsService = inject(NgxPermissionsService);

  roles$ = new BehaviorSubject<RoleView[]>([{}]);

  getUserRolesData(userId: string, organisationId: string): Promise<RoleView[]> {
    const permissions = this.ngxPermissionsService.getPermissions();
    if (
      'organisationEmployeeSpecialFieldsViewing' in permissions ||
      'onlyYourOrganisationEmployeeSpecialFieldsViewing' in permissions
    ) {
      return lastValueFrom(this.roleService.getUserRole(userId, organisationId))
        .catch(() => [])
        .then();
    }
    return new Promise(resolve => resolve([]));
  }

  getRoles(): void {
    const permissions = this.ngxPermissionsService.getPermissions();
    if (
      !('organisationEmployeeSpecialFieldsViewing' in permissions) &&
      !('onlyYourOrganisationEmployeeSpecialFieldsViewing' in permissions)
    ) {
      this.roles$.next([]);
      return;
    }

    this.roleService
      .getRoles()
      .pipe(
        catchError(err => {
          // TODO: Вернуть отображение ошибки после решения задачи #9960
          // this.alertService.error(err, { autoClose: 30000 });
          return throwError(() => err);
        }),
      )
      .subscribe(roles => this.roles$.next(roles));
  }

  resetRoles(): void {
    this.roles$.next([{}]);
  }

  resetAll(): void {
    this.resetRoles();
  }
}
